<!-- 添加或编辑用户 -->
<template>
  <div>
    <div class="model-box">
      <div class="model-title">
        <span>基本信息</span>
      </div>
      <div class="model-content">
        <table class="public-table jbxx-table">
          <tr>
            <td class="td-head">公司名称</td>
            <td>
              <el-input v-model="userInfo.companyName" placeholder="" clearable></el-input>
            </td>
            <td class="td-head">公司简称</td>
            <td>
              <el-input v-model="userInfo.shortName" placeholder="" clearable></el-input>
            </td>
          </tr>
          <tr>
            <td class="td-head">公司类型</td>
            <td>
              <el-radio @change="selectChange()" v-for="(item,index) in companyLxOptions" :key="index" v-model="userInfo.companyType" :label="item.value">{{item.name}}</el-radio>
            </td>
            <td class="td-head">用户类型</td>
            <td>
              <el-radio v-for="(item,index) in userLxOptions" :key="index" v-model="userInfo.userType" :label="item.value">{{item.name}}</el-radio>
            </td>
          </tr>
          <tr>
            <td class="td-head">联系人</td>
            <td>
              <el-input v-model="userInfo.userName" placeholder="" clearable></el-input>
            </td>
            <td class="td-head">联系电话</td>
            <td>
              <el-input v-model="userInfo.phone" placeholder="" clearable></el-input>
            </td>
          </tr>
          <tr>
            <td class="td-head">默认密码</td>
            <td>
              <el-input v-model="userInfo.userPassword" placeholder="" clearable></el-input>
            </td>
            <td class="td-head">IP</td>
            <td>
              <el-input v-model="userInfo.accessIP" placeholder="" clearable></el-input>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="model-box">
      <div class="model-title">
        <span>测试接口配置</span>
      </div>
      <div class="model-content">
        <span class="model-content-title">时间设置</span>
        <table class="public-table jbxx-table">
          <tr>
            <td class="td-head">测试时间段</td>
            <td>
              <el-select v-model="userInfo.testPeriod" @change="timeChangeFun()" placeholder="请选择">
                <el-option
                  v-for="(item,index) in sjdOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
            <td class="td-head">测试起始时间</td>
            <td>
              <el-date-picker
                v-model="userInfo.testStart"
                type="date"
                :clearable="false"
                @change="timeChangeFun()"
                placeholder="选择日期">
              </el-date-picker>
            </td>
          </tr>
           <tr>
            <td class="td-head">测试结束时间</td>
            <td>
              <span>{{userInfo.testEnd}}</span>
            </td>
            <td class="td-head"></td>
            <td>
              
            </td>
          </tr>
        </table>
        <span class="model-content-title">接口设置</span>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in ApiList" :key="index" :label="item.interDesc" :name="item.interId">
            <el-table
              v-if="activeName==item.interId"
              ref="multipleTable"
              :data="item.items"
              border
              header-row-class-name="tableHead"
              style="width: 65.2%"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange">
              <el-table-column
                type="selection"
                align="center"
                width="50">
              </el-table-column>
              <el-table-column
                prop="interDesc"
                label="接口名称"
                min-width="56%">
              </el-table-column>
              <el-table-column
                label="测试调用数量"
                min-width="44%">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.interfaceTestTotal" placeholder="请输入测试调用次数"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <a class="select-box-btn" @click="sureFun()">确定</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAddOrEditUser',
  data () {
    return {
      isEdit:this.$route.query.type || '',
      userInfo:{
        id:this.$route.query.id || '',
        companyName:'',
        shortName:'',
        companyType:'',
        userType:'',
        userName:'',
        phone:'',
        comId:'',
        testPeriod:'',
        testStart:new Date(),
        testEnd:'',
        userPassword:'123456',
        accessIP:''
      },
      Authorization:JSON.parse(Base64.decode(localStorage.getItem('Authorization').split('.')[1])),
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      sjdOptions:[],
      activeName: '',
      ApiList:[],
      accountInfo:{
        selectApiArr:[],
      },
      companyLxOptions:[],
      userLxOptions:[],
      userLxOptions1:[
        {"id":21,"name":"普通用户","value":"2","type":"user_type","remark":"用户类型"},
        {"id":22,"name":"管理员","value":"3","type":"user_type","remark":"用户类型"},
        {"id":23,"name":"超级管理员","value":"1","type":"user_type","remark":"用户类型"}
      ],
      multipleSelectionAll: {},   // 所有选中的数据包含跨页数据
      multipleSelection: [],   // 当前页选中的数据
    }
  },
  mounted () {
    var _this=this;
    _this.sjdOptions=_this.dictionary.term_type;
    if(_this.Authorization.comType=='1'){
      // _this.userLxOptions=_this.dictionary.user_type;
      _this.companyLxOptions=_this.dictionary.com_type;
    }else if(_this.Authorization.comType=='2'){
      _this.companyLxOptions=[{
        id:2,
        name:"客户",
        value:"3",
        type:"com_type",
        remark:"公司类型"
      }];
      _this.userLxOptions=[{
        id:4,
        name:"普通客户",
        value:"2",
        type:"user_type",
        remark:"用户类型"
      }];
    };
    if(_this.isEdit=="add"){
      _this.addApiDataFun();
      _this.userInfo.companyType=_this.companyLxOptions[0].value;
      if(_this.Authorization.comType=='1'){
        _this.userLxOptions=[];
        if(_this.userInfo.companyType==1){
          //道口金科
          _this.userLxOptions.push(_this.userLxOptions1[2]);
        }else if(_this.userInfo.companyType==2){
          //渠道
          _this.userLxOptions.push(_this.userLxOptions1[1]);
        }else if(_this.userInfo.companyType==3){
          //客户
          _this.userLxOptions.push(_this.userLxOptions1[0]);
        };
      };
      _this.userInfo.userType=_this.userLxOptions[0].value;
      _this.userInfo.testPeriod="1";
      _this.userInfo.testStart=this.$common.format(_this.userInfo.testStart,"yyyy-MM-dd");
      _this.userInfo.testEnd=_this.addmulMonth(_this.userInfo.testStart,_this.userInfo.testPeriod);
      _this.userInfo.testEnd=_this.getNextDate(_this.userInfo.testEnd,-1);
    }else if(_this.isEdit=="edit"){
      _this.editInfoDataFun(1);
      _this.editInfoDataFun(5);
    };
  },
  methods:{
    handleClick(tab, event) {
      var _this=this;
      // console.log(tab, event);
      _this.$nextTick(() => {
        var tabData=[];
        _this.ApiList.forEach(function(dataItem){
          if(dataItem.interId==_this.activeName){
            tabData=dataItem.items;
          };
        })
        if(_this.multipleSelectionAll[_this.activeName]){
          _this.multipleSelectionAll[_this.activeName].forEach(function(item){
            tabData.forEach(function(dataItem){
              if (item.interId == dataItem.interId) {
                _this.$refs.multipleTable[0].toggleRowSelection(dataItem, true)
              }
            })
          })
        }
      });
    },
    // 新增用户获取所有接口列表
    addApiDataFun:function(){
      var _this=this;
      _this.$axios.post("/requestApi/manage/find/allInterface")     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            _this.ApiList=[];
            data.data.forEach(function(item){
              var itemObj=new Object();
              itemObj.interId=item.interId;
              itemObj.interDesc=item.interDesc;
              itemObj.items=[];
              item.items.forEach(function(itemChild){
                if(itemChild.interUrl!=null){
                  itemObj.items.push(itemChild)
                };
              });
              _this.ApiList.push(itemObj);
            });
            _this.ApiList.forEach(function(item){
              if(item.interId=='D01'){
                item.items.forEach(function(itemChild){
                  if(itemChild.interfaceTestTotal==null){
                    itemChild.interfaceTestTotal=5;
                  };
                });
              }else{
                item.items.forEach(function(itemChild){
                  if(itemChild.interfaceTestTotal==null){
                    itemChild.interfaceTestTotal=60;
                  };
                });
              };
            });
            _this.activeName=_this.ApiList[0].interId;
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    // 修改用户获取所有接口列表
    editInfoDataFun:function(type){
      var _this=this;
      var sendData=new Object();
      sendData.type=type;
      sendData.userId=_this.userInfo.id;
      _this.$axios.post("/requestApi/manage/find/user/information",sendData)     
        .then(function(response){
          let data = response.data;
          // console.log("================="+JSON.stringify(data));
          if(data.meta.retCode==0){   
            if(type==1){
              _this.userInfo.companyName=data.data.comName;
              _this.userInfo.shortName=data.data.comBriefName?data.data.comBriefName:'';
              _this.userInfo.companyType=data.data.comType;
              if(_this.Authorization.comType=='1'){
                _this.userLxOptions=[];
                if(_this.userInfo.companyType==1){
                  //道口金科
                  _this.userLxOptions.push(_this.userLxOptions1[2]);
                }else if(_this.userInfo.companyType==2){
                  //渠道
                  _this.userLxOptions.push(_this.userLxOptions1[1]);
                }else if(_this.userInfo.companyType==3){
                  //客户
                  _this.userLxOptions.push(_this.userLxOptions1[0]);
                };
              };
              _this.userInfo.userType=String(data.data.roleList[0].id);
              _this.userInfo.userName=data.data.userName;
              _this.userInfo.comId=data.data.comId;
              _this.userInfo.phone=data.data.userPhone;
              _this.userInfo.testStart=data.data.testStartTime;
              _this.userInfo.testEnd=data.data.testEndTime;
              _this.userInfo.testEnd=data.data.testEndTime;
              _this.userInfo.testPeriod=data.data.testTerm;
              _this.userInfo.userPassword=data.data.userPassword;
              _this.userInfo.accessIP=data.data.accessIP;
            }else if(type==5){
              _this.ApiList=[];
              data.data.forEach(function(item){
                var itemObj=new Object();
                itemObj.interId=item.interId;
                itemObj.interDesc=item.interDesc;
                itemObj.items=[];
                item.items.forEach(function(itemChild){
                  if(itemChild.interUrl!=null){
                    itemObj.items.push(itemChild)
                  };
                });
                _this.ApiList.push(itemObj);
              });
              _this.ApiList.forEach(function(item){
                _this.multipleSelectionAll[item.interId]=[];
                if(item.interId=='D01'){
                  item.items.forEach(function(itemChild){
                    if(itemChild.interfaceTestTotal==null){
                      itemChild.interfaceTestTotal=5;
                    };
                    if(itemChild.isBinding==1){
                      _this.multipleSelectionAll[item.interId].push(itemChild);
                    };
                  });
                }else{
                  item.items.forEach(function(itemChild){
                    if(itemChild.interfaceTestTotal==null){
                      itemChild.interfaceTestTotal=60;
                    };
                    if(itemChild.isBinding==1){
                      _this.multipleSelectionAll[item.interId].push(itemChild);
                    };
                  });
                }
              });
              _this.handleClick();
              _this.activeName=_this.ApiList[0].interId;
            };
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    //点击表格复选框
    handleSelectionChange: function(arr) {
      var _this=this;
      _this.multipleSelection = arr;
      _this.multipleSelectionAll[_this.activeName]=_this.multipleSelection;
    },
    timeChangeFun:function(){
      var _this=this;
      _this.userInfo.testStart=this.$common.format(_this.userInfo.testStart,"yyyy-MM-dd");
      _this.userInfo.testEnd=_this.addmulMonth(_this.userInfo.testStart,_this.userInfo.testPeriod);
      _this.userInfo.testEnd=_this.getNextDate(_this.userInfo.testEnd,-1);
    },
    addmulMonth: function(date, monthNum){    
      var dateArr = date.split('-');
      var year = dateArr[0]; //获取当前日期的年份
      var month = dateArr[1]; //获取当前日期的月份
      var day = dateArr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + parseInt(monthNum);
      if (month2 >12) {
        year2 = parseInt(year2) + parseInt((parseInt(month2) / 12 == 0 ? 1 : parseInt(month2) / 12));
        month2 = parseInt(month2) % 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      return t2;
    },
    // day 传-1表始前一天，传1表始后一天
    getNextDate: function(date,day) {  
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    sureFun:function(){
      var _this=this;
      if(_this.userInfo.companyName==''){
        _this.$message("请输入公司名称");
      }else if(_this.userInfo.shortName==''){
        _this.$message("请输入公司简称");
      }else if(_this.userInfo.userName==''){
        _this.$message("请输入联系人");
      }else if(_this.userInfo.phone==''){
        _this.$message("请输入手机号");
      }else if(!this.$common.testPhone(_this.userInfo.phone)){
        _this.$message("请检查输入手机号");
      }else if(_this.userInfo.userPassword==''){
        _this.$message("请输入密码");
      }else{
        var loading = this.$loading({
          lock: true,
          text: '请求中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var selectenData=[];
        for(var value in _this.multipleSelectionAll){
          if(_this.multipleSelectionAll[value].length>0){
            _this.multipleSelectionAll[value].forEach(function(item){
              selectenData.push(item);
            });
          }
        };
        var sendData=new Object();
        sendData.userId=_this.userInfo.id;
        sendData.comName=_this.userInfo.companyName;
        sendData.comBriefName=_this.userInfo.shortName;
        sendData.comType=_this.userInfo.companyType;
        sendData.role=_this.userInfo.userType;
        sendData.comId=_this.userInfo.comId;
        sendData.userName=_this.userInfo.userName;
        sendData.accessIP=_this.userInfo.accessIP;
        sendData.userPhone=_this.userInfo.phone;
        sendData.testStartTime=this.$common.format(_this.userInfo.testStart,"yyyy-MM-dd");
        sendData.testEndTime=_this.userInfo.testEnd;
        sendData.testTerm=_this.userInfo.testPeriod;
        sendData.interfaceBindReqVoList=selectenData;
        sendData.userPassword=_this.userInfo.userPassword;
        _this.$axios.post('/requestApi/manage/add/user',sendData)      
          .then(function(response){
            loading.close();
            let data = response.data;
            if(data.meta.retCode==0){
              _this.$message({
                message: '保存成功',
                type: 'success'
              });
              _this.$router.push({path:'/yhgl'});
            }else{
              _this.$message({
                message: data.meta.friendlyMsg,
                type: 'warning'
              });
            }
          })
          .catch(function(error){
            loading.close();
            console.log(error)
          });
      }
    },
    //点击公司类型
    selectChange:function(){
      var _this=this;
      _this.userLxOptions=[];
      if(_this.userInfo.companyType==1){
        //道口金科
        _this.userLxOptions.push(_this.userLxOptions1[2]);
      }else if(_this.userInfo.companyType==2){
        //渠道
        _this.userLxOptions.push(_this.userLxOptions1[1]);
      }else if(_this.userInfo.companyType==3){
        //客户
        _this.userLxOptions.push(_this.userLxOptions1[0]);
      };
      _this.userInfo.userType=_this.userLxOptions[0].value;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jbxx-table tr td{width: 35%;}
.jbxx-table tr .td-head{width: 15%;}
.select-box-btn{margin: 0 auto; margin-top: 20px;}
.model-content-title:nth-child(1){margin-top: 0px;}
</style>



// WEBPACK FOOTER //
// src/components/UserAddOrEditUser.vue